import React from "react";
import { withRouter } from "react-router-dom";

import Slider from "rc-slider";
import { defineGrid, extendHex } from "honeycomb-grid";

import { Button, ButtonGroup } from "aible";

import { ScrollSync, ScrollSyncPane } from "react-scroll-sync";
import { Modal, Popover, OverlayTrigger } from "react-bootstrap";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import numeral from "numeral";
import moment from "moment";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faCircleNotch,
  faCheck,
  faExclamationTriangle,
  faExclamation,
  faMagic,
  faSearch
} from "@fortawesome/free-solid-svg-icons";

import BusinessConstraintsContainer from "containers/Business/Strategy/BusinessConstraints";
import HexGridContainer from "containers/Next/HexGrid";

import Select from "react-select";
import TransformIcon from "images/Next-Icons/TransformIcon.svg";
import JoinIcon from "images/Next-Icons/JoinIcon.svg";
import DropIcon from "images/Next-Icons/DropIcon.svg";
import ExploreIcon from "images/Next-Icons/ExploreIcon.svg";
import TrainIcon from "images/Next-Icons/TrainIcon.svg";
import BlueprintIcon from "images/Next-Icons/BlueprintIcon.svg";

import PredictIcon from "images/Next-Icons/PredictIcon.svg";
import BusinessIcon from "images/Next-Icons/BusinessIcon.svg";
import FairnessIcon from "images/Next-Icons/FairnessIcon.svg";
import ResourceIcon from "images/Next-Icons/ResourceIcon.svg";
import RocketIcon from "images/Next-Icons/RocketIcon.svg";

import ReviewDeployIcon from "images/Next-Icons/OrangeRocketIcon.svg";
import IntegrateIcon from "images/Next-Icons/OrangeIntegrateIcon.svg";
import MonitorSettingsIcon from "images/Next-Icons/OrangeMonitorSettingsIcon.svg";

import MagnifierIcon from "images/Next-Icons/MagnifierIcon.svg";
import HexIconBackground from "images/Next-Icons/HexIconBackground.svg";
import CheckmarkIcon from "images/Next-Icons/CheckmarkIcon.svg";
import PurpleBlueprintIcon from "images/Next-Icons/PurpleBlueprintIcon.svg";
import PurpleCompassIcon from "images/Next-Icons/PurpleCompassIcon.svg";
import FunnelIcon from "images/Next-Icons/FunnelIcon.svg";
import CashIcon from "images/Next-Icons/CashIcon.svg";
import HeartLifelineIcon from "images/Next-Icons/HeartLifelineIcon.svg";
import StethoscopeIcon from "images/Next-Icons/BlueStethoscopeIcon.svg";
import LabVialIcon from "images/Next-Icons/LabVialIcon.svg";
import SecurityCheckIcon from "images/Next-Icons/GreenSecurityCheckIcon.svg";
import WaypointIcon from "images/Next-Icons/WaypointIcon.svg";
import BullseyeIcon from "images/Next-Icons/BullseyeIcon.svg";
import MiniFunnelIcon from "images/Next-Icons/MiniFunnelIcon.svg";
import NewMoneyIcon from "images/Next-Icons/NewMoneyIcon.svg";
import MoneyIconLight from "images/Next-Icons/money-bill-light 2.svg";
import FairnessScalesIcon from "images/Next-Icons/FairnessScalesIcon.svg";
import ExpertIcon from "images/Next-Icons/ExpertIcon.svg";
import ResumeIcon from "images/Next-Icons/ResumeIcon.svg";
import MicroscopeIcon from "images/Next-Icons/BlueMicroscopeIcon.svg";
import ReturnIcon from "images/Next-Icons/ReturnIcon.svg";
import GearsIcon from "images/Next-Icons/BlueGearsIcon.svg";
import ChartIcon from "images/Next-Icons/BlueChartIcon.svg";
import SpreadsheetIcon from "images/Next-Icons/BlueSpreadsheetIcon.svg";
//import ScalesIconWhiteBackground from "images/Next-Icons/ScalesIconWhiteBackground.svg";
import ScalesIconWhiteBackground from "images/Next-Icons/GreenScalesIcon.svg";
import DatasetSettingsIcon from "images/Next-Icons/DatasetSettings.svg";

import * as nextReducer from "containers/Next/NextReducer";
import { SegmentMetric } from "utils/optimizer/ProjectOptimizer";

import styles from "./style.module.css";

export default class NextModels extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isDeployingProject: false,
      skippedNodes: {}
    };
  }

  componentDidMount() {
    setTimeout(() => {
      nextReducer.centerHex({ x: 3, y: 3 });
    }, 100);
  }

  renderMinimap(node) {
    const { id, dataset, innerHexSize } = this.props;

    return (
      <OverlayTrigger
        placement="top"
        trigger={["hover"]}
        rootClose
        overlay={
          <Popover id="popover-positioned-top">
            <div>{dataset?.label}</div>
          </Popover>
        }
      >
        <div
          className={styles.minimap}
          style={
            innerHexSize < 130
              ? {
                  marginLeft: "-110px",
                  marginTop: "-90x",
                  transform: "scale(1)"
                }
              : innerHexSize < 190
                ? { marginLeft: "-140px", marginTop: "-75px" }
                : {}
          }
        >
          <div className={styles.mGrid}>
            <HexGridContainer id={id} isMini isTile mType={"TRANSFORM"} />
          </div>
        </div>
      </OverlayTrigger>
    );
  }

  renderSetupText(node) {
    const { optimized, blueprintText } = this.props;

    const setup = node?.afterSetup || optimized?.setup || {};

    const subgroup = setup.splitColumn;
    const ignoredColumnCount = setup.ignored ? Object.keys(setup.ignored).length : 0;
    const ignoredValueCount = setup.ignoredValue ? Object.keys(setup.ignoredValue).length : 0;

    const baselineCount = setup.baselineCounts
      ? setup.baselineCounts?.truePositive +
        setup.baselineCounts?.falsePositive +
        setup.baselineCounts?.trueNegative +
        setup.baselineCounts?.falseNegative
      : setup.truePositive + setup.falsePositive + setup.trueNegative + setup.falseNegative;

    const totalCount = setup.truePositive + setup.falsePositive + setup.trueNegative + setup.falseNegative;

    const outcomePct = optimized?.outcomePercentage;
    const oOutcomePct = optimized?.originalOutcomePercentage || optimized?.outcomePercentage;

    const bStyle = {
      fontWeight: "bold",
      marginLeft: "3px",
      marginRight: "3px"
    };

    const selectedBlueprint = optimized && optimized.blueprint && optimized.blueprint.name;

    return node.leftSection === "BLUEPRINT" ? (
      <div>
        {/* <div style={{ marginBottom: "10px", fontWeight: "bold" }}>
          {selectedBlueprint && <span>{selectedBlueprint}</span>}
        </div>
        <div>
          <span>{"Click here to add a blueprint"}</span>
        </div> */}
      </div>
    ) : node.leftSection === "STRATEGY" ? (
      <div>
        {/* <span>{"My overall goal is to reach"}</span>
        <span style={bStyle}>{"Revenue"}</span>
        <span>{"of at least"}</span>
        <span style={bStyle}>{"110%"}</span>
        <span>{"of baseline ($" + 110223.01 + ")"}</span> */}
      </div>
    ) : node.leftSection === "BASELINE" ? (
      <div style={{ marginLeft: "10px", marginRight: "10px" }}>
        <span>{"Every"}</span>
        <span style={bStyle}>{"Month"}</span>
        <span>{"the AI will predict"}</span>
        <span style={bStyle}>{baselineCount + " Records"}</span>
        <span>{"with a"}</span>
        <span style={bStyle}>{oOutcomePct ? (oOutcomePct * 100).toFixed(2) + "%" : "?"}</span>
        <span>{"potential"}</span>
        <div>
          <span style={bStyle}>{"Success"}</span>
          <span>{"rate"}</span>
        </div>
      </div>
    ) : node.leftSection === "EXPECTED" ? (
      baselineCount === totalCount && outcomePct === oOutcomePct ? (
        <div>
          <div>{"I expect my future monthly behavior and business costs to remain the same as my baseline"}</div>
        </div>
      ) : (
        <div style={{ marginLeft: "10px", marginRight: "10px" }}>
          <span>{"Every"}</span>
          <span style={bStyle}>{"Month"}</span>
          <span>{"I expect"}</span>
          <span style={bStyle}>{totalCount + " Records"}</span>
          <span>{"with a"}</span>
          <span style={bStyle}>{outcomePct ? (outcomePct * 100).toFixed(2) + "%" : "?"}</span>
          <span>{"potential"}</span>
          <div>
            <span style={bStyle}>{"Success"}</span>
            <span>{"rate"}</span>
          </div>
        </div>
      )
    ) : node.leftSection === "SUBGROUP" ? (
      <div>
        {subgroup ? (
          <div>
            <span>{"Subgroup: "}</span>
            <span style={bStyle}>{subgroup}</span>
          </div>
        ) : (
          <div style={{ whiteSpace: "nowrap" }}>{"No Subgroup Selected"}</div>
        )}
      </div>
    ) : (
      <div />
    );
  }

  renderModelNode(node) {
    const {
      project,
      oProject,
      deploy,
      updateActiveTab,
      isProjectLoading,
      optimized,
      isContinuous,
      modelGroups,
      showSubgroup,
      runId,
      nSetup
    } = this.props;
    const { isDeployingProject } = this.state;
    const outcome = project && project.outcome ? project.outcome : "outcome";
    let nTotalProfit = 0;
    if (isContinuous) {
      const activeSlice =
        modelGroups &&
        modelGroups.drilldownValues &&
        modelGroups.drilldownValues.filter((d) => d.runId === runId).length > 0
          ? modelGroups.drilldownValues.filter((d) => d.runId === runId)[0]
          : undefined;
      const isOverall = (activeSlice && activeSlice.value === "Overall") || showSubgroup;

      const cSetup = activeSlice?.setup ? activeSlice.setup : nSetup;
      const nExpectedContinuousValue = Number(
        isOverall && optimized ? optimized.overallExpectedContinuousValue : cSetup.expectedValueContinuous || 0
      );
      const nExpectedContinuousCount = Number(
        isOverall && optimized ? optimized.overallExpectedContinuousCount : cSetup.expectedCountContinuous || 0
      );
      const nOverallContinuousPercent = Number(
        isOverall && optimized ? optimized.overallContinuousPercent : cSetup.continuousPercent || 0
      );

      const nPotentialProfit = nExpectedContinuousValue * nExpectedContinuousCount * nOverallContinuousPercent;
      const bMetrics =
        activeSlice && activeSlice.bestModel && activeSlice.bestModel.metrics
          ? activeSlice.bestModel.metrics
          : optimized
            ? {
                underImpact: optimized.underEstimate,
                overImpact: optimized.overEstimate
              }
            : undefined;
      nTotalProfit = bMetrics ? nPotentialProfit - (bMetrics.underImpact + bMetrics.overImpact) : 0;
    }

    const activeSegment = optimized?.activeSegment;
    const subgroup = activeSegment?.conditions?.[0]?.value || "Overall";

    return project === undefined ? (
      // <div>
      //   <div className={styles.cIcon}>
      //     <FontAwesomeIcon icon={faMagic} />
      //   </div>
      //   <div className={styles.tDiv}>
      //     <span>{"Predict when " + outcome + " is "}</span>
      //     <span style={{ fontWeight: "bold", marginLeft: "3px" }}>
      //       {project?.success}
      //     </span>
      //   </div>
      //   <div className={styles.hButton}>
      //     <Button type="primary">{"Create"}</Button>
      //   </div>
      // </div>
      <div>
        <div className={styles.loading}>
          <LoadingIndicator style={{ margin: "0px" }} />
        </div>
      </div>
    ) : isProjectLoading === true ? (
      <div>
        <div className={styles.loading}>
          <LoadingIndicator style={{ margin: "0px" }} />
        </div>
        <div>{"Creating AI"}</div>
        <div className={styles.tDiv}>
          {isContinuous ? (
            <span>{"Predict " + project.outcome}</span>
          ) : (
            <React.Fragment>
              <span>{"Predict " + project.outcome + " is "}</span>
              <span style={{ fontWeight: "bold", marginLeft: "3px" }}>{project?.success}</span>
            </React.Fragment>
          )}
        </div>
      </div>
    ) : (
      <div>
        <div className={styles.tTitle}>
          {isContinuous ? numeral(nTotalProfit).format("0.0a") : numeral(project?.profit).format("0.0a")}
        </div>
        <div className={styles.pTitle}>
          {oProject?.segments && oProject?.segments.length > 1
            ? project?.netImpactLabel +
              " found" +
              (subgroup !== "Overall" ? " in " + subgroup + " subgroup " : " Overall")
            : project?.netImpactLabel + " Found"}
        </div>
        {project?.stepsRemaining === 0 ? (
          <div className={styles.tDiv}>
            <span>{"All steps completed."}</span>
          </div>
        ) : project.stepsRemaining < 0 ? (
          <div className={styles.tDiv}>
            <span>{"All recommended steps completed."}</span>
          </div>
        ) : (
          <React.Fragment />
          // <div className={styles.tDiv}>
          //   <span className={styles.fWarn}>
          //     <FontAwesomeIcon icon={faExclamationTriangle} />
          //   </span>
          //   <span style={{ fontWeight: "bold", marginRight: "3px" }}>
          //     {project?.stepsRemaining}
          //   </span>
          //   <span>{" Recommended steps not completed."}</span>
          // </div>
        )}
        {/*
          Old deploy button
          <div className={styles.deploy}>
            <Button
              disabled={isDeployingProject || project?.isCreating}
              onClick={(e) => {
                e.stopPropagation();

                if (project?.isSelectedApproved) {
                  return updateActiveTab("MONITOR");
                }
                this.setState({ isDeployingProject: true });
                return deploy(project?.projectId).then(() => {
                  this.setState({ isDeployingProject: false });
                  updateActiveTab("MONITOR");
                });
              }}
              style={{ whiteSpace: "nowrap" }}
            >
              {isDeployingProject ? (
                <LoadingIndicator
                  style={{
                    width: "20px",
                    height: "18px",
                    transform: "scale(0.30)",
                    margin: "-5px 5px 5px -5px",
                  }}
                />
              ) : project?.isSelectedApproved ? (
                "Strategy Deployed"
              ) : (
                "Deploy Strategy"
              )}
            </Button>
          </div>
        */}
      </div>
    );
  }

  renderAddJob() {
    const { updateIsCreateJob, handleBack } = this.props;

    return (
      <div
        className={styles.purpleTextIconHex}
        onClick={(e) => {
          //e.stopPropagation();
          //updateIsCreateJob(true);
        }}
      >
        <div
          //className={styles.hexIconBackground}
          //style={{ backgroundImage: `url(${HexIconBackground})` }}
          style={{ marginBottom: "10px" }}
        >
          {/* <FontAwesomeIcon icon={faSearch} /> */}
          <img src={ResumeIcon} />
        </div>
        {/*"Post a New Job Automatically"*/}
        {/* <div className={styles.cSmall}>{"(Marketplace)"}</div> */}
      </div>
    );
  }

  renderConsultant(n) {
    const { history, updateHireConsultant, consultants } = this.props;

    const node =
      consultants && consultants.find((c) => c.id === n.id)
        ? { ...consultants.find((c) => c.id === n.id), text: n.text }
        : n;

    return (
      <div
        className={styles.cTitleHex}
        onClick={(e) => {
          e.stopPropagation();
          updateHireConsultant(node?.id, !node?.isHire);
        }}
      >
        {node?.text}
        <div className={styles.cSmall}>{node?.isHire ? "(HIRED)" : "(Hire Consultant)"}</div>
      </div>
    );
  }

  renderActionIndex(index) {
    return <div className={styles.actionIndex}>{index + 1}</div>;
  }

  renderDeployed(node) {
    const { updateActiveTab } = this.props;

    return (
      <div className={styles.deployedTile}>
        <div className={styles.tNum}>{0}</div>
        <div className={styles.dTitle}>{"Transactions Monitored"}</div>
        <div className={styles.sTitle}>{"No Integration Detected"}</div>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            updateActiveTab("MONITOR");
          }}
          style={{ padding: "5px" }}
        >
          {"View Monitoring"}
        </Button>
      </div>
    );
  }

  renderDate(node) {
    const timeStamp = node?.updatedDate;

    return (
      <div className={styles.timeStamp} title={moment.utc(timeStamp).local().format("MMMM Do YYYY, h:mm:ss a")}>
        {moment.utc(timeStamp).local().fromNow()}
      </div>
    );
  }

  getInitialsFromText(text) {
    if (text === undefined) {
      return undefined;
    }

    const matches = text.match(/\b(\w)/g);
    return matches.join("").substring(0, 3);
  }

  renderExclude(node) {
    const { nodeAssign } = this.props;
    const { skippedNodes } = this.state;
    const isCompleted = node?.afterSetup !== undefined;
    const skipHex = (node) => {
      if (skippedNodes[node.id]) skippedNodes[node.id] = false;
      else skippedNodes[node.id] = true;
    };
    return isCompleted ? null : (
      <div className={styles.updateButtons}>
        <ButtonGroup>
          {node?.hasUpdate === true && (
            <Button
              style={{ padding: "3px" }}
              type={skippedNodes[node.id] ? "secondary" : "primary"}
              onClick={(e) => {
                e.stopPropagation();
                skipHex(node);
              }}
            >
              {skippedNodes[node.id] ? "Unskip" : "Skip"}
            </Button>
          )}
        </ButtonGroup>
      </div>
    );
  }

  renderStatusCircles(node) {
    const { nodeAssign, businessConstraints, impliedBusinessConstraints, innerHexSize } = this.props;

    const MAX_DISPLAY = 2;
    const assigned = nodeAssign?.[node?.id];
    const isCompleted = node?.afterSetup !== undefined || node?.isCompleted;
    const renderWarning = () => {
      const strategy = ((businessConstraints || [])[0] || { type: SegmentMetric.Profit }).type;
      const observed = ((impliedBusinessConstraints || [])[0] || { type: SegmentMetric.Profit }).type;
      return (
        <div className={styles.completeCircle}>
          <FontAwesomeIcon icon={faCheck} />
        </div>
      );
      if (strategy === observed) {
        return (
          <div className={styles.completeCircle}>
            <FontAwesomeIcon icon={faCheck} />
          </div>
        );
      } else
        return (
          <div className={styles.completeCircleGentleWarning}>
            <FontAwesomeIcon icon={faExclamation} />
          </div>
        );
    };

    return (
      <div className={styles.status} style={innerHexSize < 190 ? { left: "-35%" } : {}}>
        {assigned &&
          assigned
            ?.filter((a, i) => i < MAX_DISPLAY)
            .map((a) => (
              <div className={isCompleted ? styles.assignCircle : styles.assignCircleEmpty}>
                {this.getInitialsFromText(a?.author)}
              </div>
            ))}
        {assigned && assigned.length > MAX_DISPLAY && (
          <div className={isCompleted ? styles.assignCircle : styles.assignCircleEmpty}>
            {assigned.length - MAX_DISPLAY}
          </div>
        )}
        {(assigned && assigned.length > 0) || isCompleted === true ? <div /> : <div className={styles.emptyCircle} />}
        {isCompleted === true && node?.id === "FAIR_GUIDE" && node?.showWarning === true ? (
          <div className={styles.completeCircleGentleWarning} title="Your fairness settings may have been modified.">
            <FontAwesomeIcon icon={faExclamation} />
          </div>
        ) : isCompleted === true && node?.id === "FAIR_VALUE" && false ? (
          <div className={styles.completeCircleWarning}>
            <FontAwesomeIcon icon={faExclamation} />
          </div>
        ) : isCompleted === true && node?.id === "OPTIMIZE_STRATEGY" ? (
          renderWarning()
        ) : isCompleted === true ? (
          <div className={styles.completeCircle}>
            <FontAwesomeIcon icon={faCheck} />
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }

  renderHex(hex, x, y, innerHexSize, node, isFaded = false, mapType = "Default", buttonClass) {
    const {
      id,
      projectId,
      datasetId,
      blueprintId,
      runId,
      dataset,
      updateSelectedHex,
      selectedHex,
      savedHexMap,
      handleBack,
      hasActions,
      handleUpdate,
      handleStartBreadcrumbs,
      updateHoverNode,
      updateActiveTab,
      hasSetupChanged,
      saveUpdateBlueprint,
      todos,
      blueprintText,
      hexSize,
      isEditBlueprint,
      optimized,
      actionHexMap,
      segmentColor,
      isList,
      deployment
    } = this.props;

    if (node === undefined) {
      return <div />;
    }

    if (blueprintId === "new" || !isNaN(blueprintId)) {
      if (node?.id === "PREDICT" || node?.id === "DEPLOY") return <div />;
    }

    const isSelectedHex = selectedHex && selectedHex?.x === hex?.x && selectedHex?.y === hex?.y;

    const isDeployedNode = node?.id === "DEPLOY_REVIEW" && node?.afterSetup !== undefined && hasActions !== true;

    const background = isDeployedNode
      ? "white"
      : node?.background
        ? node?.background
        : node?.sectionType !== undefined
          ? "rgba(126, 105, 215, 1)"
          : node.afterSetup || node?.isCompleted
            ? //? "#e6e5fc"
              "white"
            : isSelectedHex
              ? //? "#E1FAFE"
                "white"
              : !node.parent
                ? "white"
                : node.parent || true
                  ? //? "white"
                    "#E6E6FC"
                  : node.color
                    ? node.color
                    : "#54C06C";

    /*
    const hoverColor =
      node.parent && node.color
        ? node.color
        : node.parent
        ? "#54C06C"
        : selectedHex && selectedHex.x === hex.x && selectedHex.y === hex.y
        ? "rgba(122, 109, 208, 1)"
        : "white";
        */

    const hoverColor =
      node?.leftSection === "HOME"
        ? segmentColor
        : node.borderColor
          ? node.borderColor
          : node.color
            ? node.color
            : "#54C06C";

    const textColor = node?.sectionType !== undefined ? "white" : hoverColor;

    const hKey = hex.x + "_" + hex.y;

    const retProps = {
      id: projectId,
      runId: projectId === "new" ? "new" : runId,
      datasetId: datasetId,
      isNext: true,
      isModelsNext: true,
      hideModel: true
    };

    const hasTodos =
      node?.selected &&
      todos &&
      Object.keys(node?.selected).length > 0 &&
      Object.keys(todos).find((t) => todos[t]?.id === node?.selected[0]?.id) !== undefined;

    const isCompleted = node?.afterSetup !== undefined || node?.isCompleted;

    return (
      <div
        id={"hexTile_" + hKey}
        key={"hex_" + hKey}
        className={styles.hexHolder}
        style={
          x !== undefined && y !== undefined
            ? {
                left: x,
                top: y,
                opacity: isFaded ? 0.3 : 1,
                zIndex: node?.index !== undefined ? node?.index + 2 : 2,
                pointerEvents: isFaded ? "none" : "all"
              }
            : { position: "relative" }
        }
        onClick={() => updateSelectedHex(hex, node)}
        onMouseEnter={() => {
          console.log(node);
          updateHoverNode(node);
        }}
        onMouseLeave={() => updateHoverNode(undefined)}
      >
        <div
          className={styles.hexagon}
          style={{
            height: innerHexSize + "px",
            width: innerHexSize * (110 / 190) + "px",
            background: background
          }}
        >
          {node?.hasUpdate && innerHexSize > 100 && this.renderStatusCircles(node)}
          {isSelectedHex ? (
            <div className={buttonClass ? buttonClass : isList ? styles.listTodoButton : styles.updateButtons}>
              <ButtonGroup>
                <Button
                  style={{ padding: "3px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleBack();
                  }}
                >
                  {"Back"}
                </Button>
                {node?.hasUpdate === true && (
                  <Button
                    style={{ padding: "3px" }}
                    type="primary"
                    onClick={(e) => {
                      if (node?.id === "OPTIMIZE_COSTS" && isEditBlueprint) {
                        saveUpdateBlueprint();
                      } else {
                        e.stopPropagation();
                        handleUpdate(hex, node);
                      }
                    }}
                    disabled={blueprintId === "new" ? false : !hasSetupChanged}
                  >
                    {node?.id === "OPTIMIZE_COSTS" && isEditBlueprint ? "Save Blueprint" : "Update"}
                  </Button>
                )}
                {node?.selected !== undefined && (
                  <Button
                    style={{ padding: "3px" }}
                    type={hasTodos ? "default" : "primary"}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleStartBreadcrumbs(node, true, hasTodos === true ? true : false);
                    }}
                  >
                    {hasTodos ? "Remove All To Do" : "Add All To Do"}
                  </Button>
                )}
              </ButtonGroup>
              {actionHexMap &&
                actionHexMap[hKey] &&
                actionHexMap[hKey]?.selected === undefined &&
                actionHexMap[hKey]?.hasUpdate &&
                actionHexMap[hKey]?.afterSetup === undefined && (
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleStartBreadcrumbs(node);
                    }}
                    style={{ padding: "3px", marginTop: "5px" }}
                  >
                    {todos[node?.id] !== undefined ? "Remove To Do" : "Add To Do"}
                  </Button>
                )}
            </div>
          ) : (
            <div>
              {actionHexMap &&
                actionHexMap[hKey] &&
                actionHexMap[hKey]?.selected === undefined &&
                actionHexMap[hKey]?.hasUpdate &&
                actionHexMap[hKey]?.afterSetup === undefined && (
                  <div className={isList ? styles.listTodoButton : styles.botButton}>
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleStartBreadcrumbs(node);
                      }}
                      style={{ padding: "3px" }}
                    >
                      {todos[node?.id] !== undefined ? "Remove To Do" : "Add To Do"}
                    </Button>
                  </div>
                )}
            </div>
          )}
          {/*""
          {actionHexMap && actionHexMap[hKey] && !isList && (
            <React.Fragment>
              {this.renderDeployedExclude(node)}
            </React.Fragment>
          )}
          */}
          {savedHexMap[hKey] && node.isSave !== true && (
            <div className={styles.hexNumber} style={{ color: textColor }}>
              {savedHexMap[hKey].length}
            </div>
          )}
          {isDeployedNode ? (
            this.renderDeployed(node)
          ) : node?.sectionType !== undefined ? (
            <div className={styles.mainSection}>
              {node?.icon !== undefined ? (
                <div className={styles.mIcon + " " + (innerHexSize < 180 ? styles.mIconSmall : "")}>
                  {node?.id === "DEPLOY" && deployment && !deployment.endpoint_url ? (
                    <LoadingIndicator
                      style={{
                        width: "70px",
                        height: "60px"
                      }}
                      color={"#FFFFFF"}
                    />
                  ) : (
                    <img
                      src={
                        node?.icon === "DatasetSettingsIcon"
                          ? DatasetSettingsIcon
                          : node?.id === "DEPLOY_REVIEW"
                            ? ReviewDeployIcon
                            : node?.id === "DEPLOY_INTEGRATION"
                              ? IntegrateIcon
                              : node?.id === "DEPLOY_MONITOR"
                                ? MonitorSettingsIcon
                                : node?.icon === "Predict"
                                  ? HeartLifelineIcon
                                  : node?.icon === "Business"
                                    ? BusinessIcon
                                    : node?.icon === "Fairness"
                                      ? FairnessIcon
                                      : node?.icon === "Resource"
                                        ? ResourceIcon
                                        : node?.icon === "Rocket"
                                          ? RocketIcon
                                          : RocketIcon
                      }
                    />
                  )}
                </div>
              ) : (
                <div className={styles.sectionIconBox} />
              )}
              {innerHexSize < 130 ? (
                <div />
              ) : (
                <div className={styles.sectionText} style={innerHexSize < 180 ? { width: "150%" } : {}}>
                  {node?.afterSetup !== undefined && node?.afterText ? node?.afterText : node?.text}
                </div>
              )}
            </div>
          ) : (
            <div
              className={styles.hText}
              style={{
                height: innerHexSize + "px",
                width: innerHexSize < 190 ? "150%" : innerHexSize * (110 / 190) + "px",
                color: textColor,
                marginLeft: innerHexSize < 190 ? "-25%" : "0px"
              }}
            >
              {node?.afterSetup && innerHexSize < 100 && <div>{"Done"}</div>}
              {node?.id === "OPTIMIZE_BLUEPRINT" && (
                <React.Fragment>
                  <div className={innerHexSize < 180 ? styles.mIconSmall : ""}>
                    <img src={WaypointIcon} />
                  </div>
                  {innerHexSize > 100 &&
                    (blueprintText ? (
                      <div>{blueprintText + " Added"}</div>
                    ) : isCompleted ? (
                      <div>Use Case Business Language Added</div>
                    ) : null)}
                </React.Fragment>
                // <div className={styles.iconHolder}>
                //   <img src={BlueprintIcon} />
                // </div>
              )}
              {node?.id !== undefined && node?.id !== "OPTIMIZE_BLUEPRINT" && (
                <div
                  className={styles.hexIcon + " " + (innerHexSize < 180 ? styles.mIconSmall : "")}
                  style={node?.id === "OUTCOME" ? { width: "50px", height: "50px" } : {}}
                >
                  <img
                    src={
                      node?.id === "OPTIMIZE_BALANCER"
                        ? FairnessScalesIcon
                        : node?.id === "OUTCOME"
                          ? DatasetSettingsIcon
                          : node?.id === "DEPLOY_REVIEW"
                            ? ReviewDeployIcon
                            : node?.id === "DEPLOY_INTEGRATION"
                              ? IntegrateIcon
                              : node?.id === "DEPLOY_MONITOR"
                                ? MonitorSettingsIcon
                                : node.id === "OPTIMIZE_STRATEGY"
                                  ? BullseyeIcon
                                  : node.id === "OPTIMIZE_TRANSACTION"
                                    ? MiniFunnelIcon
                                    : node.id === "OPTIMIZE_COSTS_BASELINE"
                                      ? MoneyIconLight
                                      : node.id === "OPTIMIZE_COSTS"
                                        ? NewMoneyIcon
                                        : node.id === "PREDICT_WHAT_IF"
                                          ? StethoscopeIcon
                                          : node.id === "DEPLOY_REVIEW"
                                            ? LabVialIcon
                                            : node.id === "FAIR_GUIDE"
                                              ? ScalesIconWhiteBackground
                                              : node.id === "FAIR_VALUE"
                                                ? SecurityCheckIcon
                                                : node.id === "BUDGET_SUBGROUP"
                                                  ? MicroscopeIcon
                                                  : node.id === "BUDGET_RETRAIN"
                                                    ? ReturnIcon
                                                    : node.id === "EVAL_MODEL_DRIVERS"
                                                      ? GearsIcon
                                                      : node.id === "REVIEW_MODEL_METRICS"
                                                        ? SpreadsheetIcon
                                                        : node.id === "REVIEW_MODEL_CHARTS"
                                                          ? ChartIcon
                                                          : null
                    }
                  />
                </div>
              )}
              {node?.type === nextReducer.HEXAGON_NODES.ADD_JOB && this.renderAddJob()}
              {false && node.text === "Dataset Name" && dataset ? dataset.label : ""}
              {innerHexSize < 130
                ? ""
                : node.leftSection === "HOME"
                  ? this.renderModelNode(node)
                  : node?.text === "Dataset Name"
                    ? this.renderMinimap(node)
                    : node.afterSetup && node.afterText
                      ? node.afterText
                      : node && Array.isArray(node) && node.length > 0
                        ? node[0].parent.text
                        : node.text === "Dataset Name" && dataset
                          ? dataset.label
                          : node.text === "Dataset Name"
                            ? "..."
                            : node.text}
              {
                node && node.hasUpdate && node.leftSection === "STRATEGY" ? (
                  <div className={styles.tDiv}>{/* <BusinessConstraintsContainer {...retProps} overviewOnly /> */}</div>
                ) : null // <div className={styles.tDiv}>{this.renderSetupText(node)}</div>
              }
              {node?.updatedDate !== undefined && mapType !== "Actions" && innerHexSize > 100 && this.renderDate(node)}
            </div>
          )}
          <div
            className={styles.face1}
            style={{
              background: background
            }}
          ></div>
          <div
            className={styles.face2}
            style={{
              background: background
            }}
          ></div>
        </div>
        <div className={styles.borderHex}>
          <div
            className={styles.hexagon}
            style={{
              height: innerHexSize + 6 + "px",
              width: innerHexSize * (110 / 190) + (6 * 110) / 190 + "px",
              background: hoverColor
            }}
          >
            <div
              className={styles.face1}
              style={{
                background: hoverColor
              }}
            ></div>
            <div
              className={styles.face2}
              style={{
                background: hoverColor
              }}
            ></div>
          </div>
        </div>
      </div>
    );
  }

  renderList() {
    const {
      id,
      hexMap,
      actionHexMap,
      savedHexMap,
      selectedHex,
      hasActions,
      hexSize,
      isLoading,
      todos,
      updateSelectedHex,
      isTodo,
      rSetupSection,
      blueprintText
    } = this.props;

    /*
    const styles =
      rSetupSection === "PREDICT_WHAT_IF"
        ? { width: "35vw" }
        : rSetupSection === "STRATEGY"
        ? { width: "100%", height: "calc(100% - 120px)", overflowY: "auto" }
        : rSetupSection === "BASELINE"
        ? {
            maxWidth: "70vw",
            maxHeight: "calc(100% - 120px)",
            marginBottom: "10px",
            overflow: "auto",
          }
        : rSetupSection === "BLUEPRINT"
        ? { height: "90%", overflowY: "scroll" }
        : rSetupSection === "ADD_JOB"
        ? { height: "calc(100% - 120px", overflowY: "auto" }
        : {};
      */

    const retStyle =
      isTodo !== true || rSetupSection === undefined ? {} : { maxWidth: "33.33vw", marginLeft: "33.33vw" };

    return (
      <div className={styles.modelList} style={retStyle}>
        {hexMap &&
          Object.keys(hexMap)
            .sort((a, b) => hexMap[a]?.index - hexMap[b]?.index)
            .map((hKey) => {
              const node = hexMap[hKey];

              const todoSteps =
                todos && Object.keys(node?.selected)
                  ? Object.keys(node?.selected)
                      .filter((k) => todos[node?.selected?.[k]?.id] !== undefined)
                      .map((k) => node?.selected[k])
                  : [];

              const rSteps = node?.selected === undefined ? 0 : Object.keys(node.selected).length - todoSteps.length;

              return (
                <div className={styles.listNode}>
                  <div className={styles.innerListNode} onClick={() => updateSelectedHex(node, node)}>
                    <div className={styles.miniHex}>
                      {this.renderHex(node, undefined, undefined, 84, node, undefined, undefined, styles.topButtons)}
                    </div>
                    <div>
                      <div className={styles.hexText}>{node?.text}</div>
                      <div className={styles.subCount}>
                        {todoSteps.length === 0
                          ? ""
                          : "To Do: " +
                            todoSteps.length +
                            " remaining steps. " +
                            todoSteps.reduce((a, b, c) => a + b?.text + (c === todoSteps.length - 1 ? "." : ", "), "")}
                      </div>
                      {rSteps > 0 && <div className={styles.subCount}>{rSteps + " recommended steps to action."}</div>}
                    </div>
                  </div>
                  {((actionHexMap && selectedHex?.id && selectedHex?.id === node?.id) ||
                    selectedHex?.parent?.id === node?.id) &&
                    Object.keys(actionHexMap)
                      .filter((aKey) => actionHexMap[aKey]?.id !== node?.id)
                      .sort((aKey, bKey) => (actionHexMap[aKey]?.afterSetup !== undefined ? 1 : -1))
                      .map((aKey) => {
                        const actionNode = actionHexMap[aKey];

                        return (
                          <div
                            className={styles.actionNode}
                            onClick={() => updateSelectedHex(actionNode, actionNode)}
                            onMouseEnter={() => console.log(actionNode)}
                          >
                            <div className={styles.miniHex}>
                              {this.renderHex(actionNode, undefined, undefined, 84, actionNode)}
                            </div>
                            <div className={styles.hexText}>
                              {actionNode?.afterSetup !== undefined && actionNode?.id === "OPTIMIZE_BLUEPRINT"
                                ? "Blueprint has been added: " + blueprintText
                                : node?.afterSeutp !== undefined
                                  ? actionNode?.afterText
                                  : actionNode?.text}
                            </div>
                          </div>
                        );
                      })}
                </div>
              );
            })}
      </div>
    );
  }

  render() {
    const { id, blueprintId, hexMap, actionHexMap, savedHexMap, selectedHex, hasActions, hexSize, isLoading, isList } =
      this.props;

    if (isLoading) {
      return (
        <div className={styles.loadSpinner}>
          <LoadingIndicator />
        </div>
      );
    }

    if (isList) {
      return this.renderList();
    }

    let hexGrid = [];

    const calcInnerHexSize = (size) => size * 1.65;
    const innerHexSize = calcInnerHexSize(hexSize);

    const Hex = extendHex({
      size: hexSize, // default: 1
      orientation: "flat" // default: 'pointy'
    });

    const Grid = defineGrid(Hex);

    Grid.hexagon({
      radius: 8,
      center: [8, 8]
    }).forEach((hex, i) => {
      const { x, y } = hex.toPoint();

      const rKey = hex.x + "_" + hex.y;

      if (actionHexMap && actionHexMap[rKey]) {
        hexGrid.push(this.renderHex(hex, x, y, innerHexSize, actionHexMap[rKey], undefined, "Actions"));
      } else if (hexMap && hexMap[rKey]) {
        hexGrid.push(
          this.renderHex(
            hex,
            x,
            y,
            innerHexSize,
            hexMap[rKey],
            hasActions && (selectedHex === undefined || selectedHex.x !== hex.x || selectedHex.y !== hex.y)
          )
        );
      } else if (savedHexMap && savedHexMap[rKey] && (savedHexMap[rKey]?.isBase || hasActions !== true)) {
        let retSaved = savedHexMap[rKey];

        if (blueprintId !== undefined && retSaved?.leftSection === "HOME") {
          retSaved = {
            x: retSaved?.x,
            y: retSaved?.y,
            text: "Dataset Settings",
            id: "OUTCOME",
            icon: undefined,
            leftSection: "OUTCOME",
            color: "#059669"
          };
        }

        hexGrid.push(this.renderHex(hex, x, y, innerHexSize, retSaved, hasActions));
      }
    });

    return hexGrid;
  }
}

export class SetupText extends React.PureComponent {
  render() {
    const {
      node,
      optimized,
      fSetup,
      nSetup,
      setupLabels,
      isContinuous,
      timePeriod,
      expectedCountContinuous,
      expectedValueContinuous
    } = this.props;

    const setup =
      (fSetup && Object.keys(fSetup).length > 0 ? fSetup : undefined) ||
      node?.afterSetup ||
      optimized?.setup ||
      nSetup ||
      {};
    const oSetup = node?.afterSetup || optimized?.setup || {};

    const subgroup = setup.splitColumn;
    const ignoredColumnCount = setup.ignored ? Object.keys(setup.ignored).length : 0;
    const ignoredValueCount = setup.ignoredValue ? Object.keys(setup.ignoredValue).length : 0;

    const baselineCount = setup.baselineCounts
      ? setup.baselineCounts?.truePositive +
        setup.baselineCounts?.falsePositive +
        setup.baselineCounts?.trueNegative +
        setup.baselineCounts?.falseNegative
      : setup.truePositive + setup.falsePositive + setup.trueNegative + setup.falseNegative;

    const totalCount = setup.truePositive + setup.falsePositive + setup.trueNegative + setup.falseNegative;

    const baselinePct = setup.baselineCounts
      ? (setup.baselineCounts?.truePositive + setup.baselineCounts?.falseNegative) / baselineCount
      : (setup.truePositive + setup.falseNegative) / baselineCount;

    const outcomePct = optimized?.outcomePercentage;
    const oOutcomePct = optimized?.originalOutcomePercentage || optimized?.outcomePercentage;

    const bStyle = {
      fontWeight: "bold",
      marginLeft: "3px",
      marginRight: "3px"
    };

    return node.leftSection === "STRATEGY" ? (
      <div>
        <span>{""}</span>
      </div>
    ) : node.leftSection === "BASELINE" ? (
      isContinuous ? (
        <div style={{ marginLeft: "10px", marginRight: "10px" }}>
          <span>{"Every"}</span>
          <span style={bStyle}>{timePeriod}</span>
          <span>{"the AI will predict"}</span>
          <span style={bStyle}>{expectedCountContinuous + " Records"}</span>
          <span>{"with a"}</span>
          <span style={bStyle}>
            {/* {oOutcomePct ? (oOutcomePct * 100).toFixed(2) + "%" : "?"} */}
            {expectedValueContinuous.toFixed(2)}
          </span>
          <div>
            <span style={bStyle}>{"Average Value"}</span>
          </div>
        </div>
      ) : (
        <div style={{ marginLeft: "10px", marginRight: "10px" }}>
          <span>{"Every"}</span>
          <span style={bStyle}>{timePeriod}</span>
          <span>{"the AI will predict"}</span>
          <span style={bStyle}>{baselineCount + " Records"}</span>
          <span>{"with a"}</span>
          <span style={bStyle}>
            {/* {oOutcomePct ? (oOutcomePct * 100).toFixed(2) + "%" : "?"} */}
            {baselinePct ? (baselinePct * 100).toFixed(2) + "%" : "?"}
          </span>
          <span>{"potential"}</span>
          <div>
            <span style={bStyle}>{"Success"}</span>
            <span>{"rate"}</span>
          </div>
        </div>
      )
    ) : node.leftSection === "EXPECTED" ? (
      baselineCount === totalCount && outcomePct === oOutcomePct ? (
        <div>
          <div>{"I expect my future monthly behavior and business costs to remain the same as my baseline"}</div>
        </div>
      ) : isContinuous ? (
        <div style={{ marginLeft: "10px", marginRight: "10px" }}>
          <div className={styles.infoLine}>
            <div className={styles.leftInfo}>{setupLabels?.overPredictAction}</div>
            <div style={bStyle}>{setup?.conversionGain}</div>
          </div>
          <div className={styles.infoLine}>
            <div className={styles.leftInfo}>{setupLabels?.underPredictAction}</div>
            <div style={bStyle}>{setup?.conversionCost}</div>
          </div>
        </div>
      ) : (
        <div style={{ marginLeft: "10px", marginRight: "10px" }}>
          <div className={styles.infoLine}>
            <div className={styles.leftInfo}>{oSetup?.truePositiveLabel}</div>
            <div style={bStyle}>{setup?.conversionGain}</div>
          </div>
          <div className={styles.infoLine}>
            <div className={styles.leftInfo}>{oSetup?.falsePositiveLabel}</div>
            <div style={bStyle}>{setup?.conversionCost}</div>
          </div>
          <div className={styles.infoLine}>
            <div className={styles.leftInfo}>{oSetup?.trueNegativeLabel}</div>
            <div style={bStyle}>{setup?.conversionSaved}</div>
          </div>
          <div className={styles.infoLine}>
            <div className={styles.leftInfo}>{oSetup?.falseNegativeLabel}</div>
            <div style={bStyle}>{setup?.conversionMissed}</div>
          </div>
        </div>
      )
    ) : node.leftSection === "SUBGROUP" ? (
      <div>
        {subgroup ? (
          <div>
            <span>{"Subgroup: "}</span>
            <span style={bStyle}>{subgroup}</span>
          </div>
        ) : (
          <div style={{ whiteSpace: "nowrap" }}>{"No Subgroup Selected"}</div>
        )}
      </div>
    ) : (
      <div />
    );
  }
}
